import { isAxiosError } from 'axios'

import type { ApiDeviceSystemData } from '../apiTypes'
import type {
  ApiV1DeviceCheckSubscriptionPostRequest,
  DeviceApi,
} from '../generated'
import { createAPISlice } from './createAPISlice'
import i18n from '~/i18n'

export default function createDeviceApis(deviceApi: DeviceApi) {
  return createAPISlice(
    {
      checkSubscription: async (
        params: ApiV1DeviceCheckSubscriptionPostRequest,
      ) => {
        return await deviceApi.apiV1DeviceCheckSubscriptionPost(params)
      },
      getLastCalibration: async ({
        serialNumber,
      }: {
        serialNumber: string
      }) => {
        return await deviceApi.apiV1DeviceLastCalibrationPost({
          serialNumber,
        })
      },
      postAppStartData: async (
        raptorSerialNumber: string,
        {
          timestamp,
          data,
        }: {
          timestamp: Date
          data: ApiDeviceSystemData
        },
      ) => {
        return await deviceApi.apiV1DeviceSaveSystemDataPost({
          serialNumber: raptorSerialNumber,
          data: {
            S_5: data.runtime,
            S_6: data.HVruntime,
            S_7: data.PCC,
            S_8: data.URC,
            S_9: data.BCCFG,
            S_10: data.BSOHFG,
            S_11: data.BSRCWLFG,
            S_12: data.MCC,
            S_16: data.LLBV,
            S_17: data.NOBCC,
            S_18: data.APCI,
            S_19: data.SOTC,
            S_23: data.HighTemp,
            S_24: data.LowTemp,
            S_26: data.HTESP,
            S_27: data.LTESP,
            S_29: data.HTSTM,
            S_30: data.LTSTM,
            S_32: data.HTCHG,
            S_33: data.LTCHG,
            S_35: data.HTHVS,
            S_36: data.LTHVS,
            S_38: data.APOTI,
            S_44: data.MRCDC,
            S_54: data.SpkVolSys,
            S_57: data.Battruntime,
            S_60: data.Usrruntime,
            S_61: data.UnintShutd,
            S_62: data.OverTemp,
          },
          source: 'bluetooth',
          timestamp: timestamp.toISOString(),
        })
      },
    },
    {
      checkSubscription: (error, data) => {
        if (isAxiosError(error) && error.status === 404) {
          const params = data[0]
          return {
            message: i18n.t('errors.API.checkSubscription.deviceNotFound', {
              serialNumber: params.serialNumber,
            }),
          }
        }
      },
    },
  )
}
